import React from "react";
import PropTypes from 'prop-types';
import { Wrapper } from "./atoms";
import { Tab } from "./components";

export const TabsFilter = ({ tabs }) => {

  return (
    <Wrapper>
      {tabs.map(tab => (
        <Tab key={tab.title} tab={tab} />
      ))}
    </Wrapper>
  );
}

TabsFilter.propTypes = {
  tabs: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string.isRequired,
    onClick: PropTypes.func,
    icon: PropTypes.string,
    svg: PropTypes.node,
    count: PropTypes.number,
    selected: PropTypes.bool,
  })).isRequired,
};
